export const UPDATE_THEME = 'UPDATE_THEME';

const updateThemeAction = (payload) => {
  return { type: UPDATE_THEME, payload };
};

// Reference for middleware concept
// export const updateThemeRequest = () => {
//   return { type: UPDATE_THEME_REQUEST };
// };
// export const updateThemeSuccess = (payload) => {
//   return { type: UPDATE_THEME_SUCCESS, payload };
// };
// export const updateThemeFailure = () => {
//   return { type: UPDATE_THEME_FAILURE };
// };

// export const updateTheme = (payload) => {
//   updateThemeRequest();
//   if (payload) {
//     updateThemeSuccess(payload);
//   } else {
//     updateThemeFailure();
//   }
// };

export const updateTheme = (payload) => {
  return updateThemeAction(payload);
};
